/*
  Favoritos — Spirit Club.

  Guarda uma lista de handles de produto no localStorage do visitante. Sem app,
  sem conta e sem servidor: e o unico jeito de ter favoritos numa loja que ainda
  nao tem contas de cliente.

  O que isso NAO faz, e e bom estar escrito: nao sincroniza entre aparelhos, nao
  sobrevive a limpeza dos dados do navegador e nao chega ate a loja — ninguem
  consegue relatorio do que foi favoritado. Se um dia isso for necessario, o
  caminho e conta de cliente ou app, nao este arquivo.

  Toda leitura e escrita passa por try/catch porque localStorage lanca excecao,
  e nao devolve null, em aba anonima com dados de site bloqueados. Sem a guarda,
  uma excecao aqui derrubaria o resto do JS da pagina.
*/
(() => {
  const CHAVE = 'spirit:favoritos';
  const EVENTO = 'spirit:favoritos-alterado';

  const ler = () => {
    try {
      const cru = JSON.parse(localStorage.getItem(CHAVE));
      return Array.isArray(cru) ? cru.filter((h) => typeof h === 'string') : [];
    } catch (e) {
      return [];
    }
  };

  const gravar = (lista) => {
    try {
      localStorage.setItem(CHAVE, JSON.stringify(lista));
    } catch (e) {
      /* aba anonima ou armazenamento cheio: o botao segue funcionando na sessao */
    }
    window.dispatchEvent(new CustomEvent(EVENTO, { detail: { lista } }));
  };

  const contem = (handle) => ler().indexOf(handle) !== -1;

  const alternar = (handle) => {
    const lista = ler();
    const i = lista.indexOf(handle);
    if (i === -1) lista.push(handle);
    else lista.splice(i, 1);
    gravar(lista);
    return i === -1;
  };

  /* Exposto para a pagina de favoritos e para depuracao no console. */
  window.spiritFavoritos = { ler, contem, alternar, CHAVE, EVENTO };

  /* --- Botao de estrela ------------------------------------------------- */

  class SpiritFavorito extends HTMLElement {
    connectedCallback() {
      this.botao = this.querySelector('button');
      this.handle = this.getAttribute('data-handle');
      if (!this.botao || !this.handle) return;

      this.rotulo = this.querySelector('[data-rotulo]');
      this.pintar();

      this.botao.addEventListener('click', (evento) => {
        /* O card inteiro e uma area clicavel no Dawn (o link do titulo se
           estica por cima com ::after). Sem parar o evento aqui, favoritar
           levaria junto para a pagina do produto. */
        evento.preventDefault();
        evento.stopPropagation();
        alternar(this.handle);
      });

      this.aoMudar = () => this.pintar();
      window.addEventListener(EVENTO, this.aoMudar);
      /* outra aba mexeu na mesma lista */
      window.addEventListener('storage', (e) => {
        if (e.key === CHAVE) this.pintar();
      });
    }

    disconnectedCallback() {
      if (this.aoMudar) window.removeEventListener(EVENTO, this.aoMudar);
    }

    pintar() {
      const ativo = contem(this.handle);
      this.botao.setAttribute('aria-pressed', ativo ? 'true' : 'false');
      this.classList.toggle('spirit-favorito--ativo', ativo);
      if (this.rotulo) {
        this.rotulo.textContent = ativo
          ? this.getAttribute('data-rotulo-remover') || 'Remover dos favoritos'
          : this.getAttribute('data-rotulo-salvar') || 'Salvar nos favoritos';
      }
    }
  }

  if (!customElements.get('spirit-favorito')) {
    customElements.define('spirit-favorito', SpiritFavorito);
  }

  /* --- Contador no cabecalho -------------------------------------------- */

  const atualizarContadores = () => {
    const n = ler().length;
    document.querySelectorAll('[data-favoritos-contador]').forEach((el) => {
      el.textContent = n;
      /* o numero some quando e zero: um "0" permanente no cabecalho parece
         erro, nao estado */
      el.hidden = n === 0;
    });
  };

  atualizarContadores();
  window.addEventListener(EVENTO, atualizarContadores);
  window.addEventListener('storage', (e) => {
    if (e.key === CHAVE) atualizarContadores();
  });

  /* --- Pagina de favoritos ---------------------------------------------- */

  /*
    A pagina imprime, escondido, o card de cada produto da loja e aqui so
    aparecem os favoritados. Parece desperdicio, mas com um catalogo pequeno
    e a opcao mais simples e mais fiel: o card e o mesmo Liquid da vitrine,
    entao nao existe uma segunda marcacao de card em JavaScript para sair do
    lugar quando a primeira mudar.

    O limite esta declarado no schema da secao. Se o catalogo crescer muito,
    a troca e buscar `/products/<handle>.js` por favorito — ai vale pagar o
    custo de montar o card no cliente.
  */
  const montarPagina = () => {
    const area = document.querySelector('[data-favoritos-lista]');
    if (!area) return;

    const salvos = ler();
    let visiveis = 0;

    area.querySelectorAll('[data-favoritos-item]').forEach((item) => {
      const dentro = salvos.indexOf(item.getAttribute('data-favoritos-item')) !== -1;
      item.hidden = !dentro;
      if (dentro) visiveis += 1;
    });

    const vazio = document.querySelector('[data-favoritos-vazio]');
    if (vazio) vazio.hidden = visiveis > 0;
    area.hidden = visiveis === 0;
  };

  montarPagina();
  window.addEventListener(EVENTO, montarPagina);
  window.addEventListener('storage', (e) => {
    if (e.key === CHAVE) montarPagina();
  });
})();
